import moment from 'moment';
import React from 'react';
import { View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../constants/Colorsv2';
import { Text, TouchableOpacity } from '../globalComponents/NativeOverrides';
import { market_getOddsLabel } from '../screensV1/Event/helpers/markets';
import { market_cancelOrder } from '../store/actionsv1/markets';
import { PlayerReferralProps, PublicPlayerProps } from '../store/types/auth_svc';
import { OrderProps } from '../store/types/mk_svc';
import OrderGradeBar from './OrderGradeBar';
import { Icon } from 'react-native-elements';

type BuyNowOrderCardProps = {
    order:OrderProps
    onBuy:(order:OrderProps) => void
}
const BuyNowOrderCard = ({ order, onBuy }:BuyNowOrderCardProps) => {
    const dispatch = useDispatch();

    const player_referral:PlayerReferralProps | undefined = useSelector((state:any) => state.player.player_referral, (left, right) => left?.last_update_datetime == right?.last_update_datetime)
    const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const me = order.player_id == player?.player_id ? true : false
    const cl = order.market_type === 'FOR_MONEY' ? '$' : 'E'

    const handleBuyNow = () => {
        if(!onBuy){ return }
        onBuy({
             ...order, 
             open_amt: Math.floor(order.open_amt * 100) / 100,
             influencer_id:undefined,
             influence_type: undefined,
             draft_liquidity: Math.floor(order.open_amt * 100)/100,
             tip_pct:undefined,
             tip_type:undefined,
             expire_datetime: moment().add(1, 'minutes'), 
             order_type: 'limit', 
             buy_sell_ind: 'buy' 
            })
    }


    const handleShare = async() => {
        let url = `https://share.mybe.app/qo?order=${order.order_id}`
        if(player_referral){
            url = `https://share.mybe.app/qo?order=${order.order_id}&refer=${player_referral.referral_code}`
        }
        if(navigator.share){
            return navigator.share({title:'Checkout this availble bet on BettorEdge', url }).then(() => console.log('shared')).catch((e) => console.log(e))
        }
        return alert('Your browser does not support sharing.  Either switch to a mobile browser or copy and past the code')
    }


    return (
        <View style={styles.orderCard}>
            <View style={{ padding:15 }}>
                <Text size={12} color={Colors.shades.black} weight='bold' textAlign='center'>{order.title}</Text>
                <Text style={{ margin:3 }} size={12} color={Colors.shades.black} weight='regular' textAlign='center'>{cl}{order.open_amt.toFixed(2)} to win {cl}{order.potential_winnings.toFixed(2)}</Text>
                <Text style={{ margin:3 }} size={12} color={Colors.shades.black} weight='bold' textAlign='center'>PRICE</Text>
                <Text style={{ margin:3 }} size={12} color={Colors.brand.electric} weight='bold' textAlign='center'>{(order.probability * 100).toFixed(2)}% ({market_getOddsLabel(order.odds)})</Text>
                
                <View style={{ justifyContent:'center', alignItems:'center', padding:5 }}>
                    <OrderGradeBar grade={order.grade} view_type='card' />
                </View>
            </View>
            <View style={{ flexDirection:'row', borderBottomLeftRadius:10, borderBottomRightRadius:10 }}>
                <TouchableOpacity style={{ padding:10, backgroundColor:Colors.brand.electric, borderBottomLeftRadius:10 }} onPress={() => handleShare()}>
                    <Icon name='share' color={Colors.shades.white} size={18} type='feather' />
                </TouchableOpacity>
                {me ?
                <TouchableOpacity style={{ flex:1, padding:10, backgroundColor:Colors.utility.error, borderBottomRightRadius:10 }} onPress={() => dispatch(market_cancelOrder(order.order_id))}>
                    <Text size={14} color={Colors.shades.white} weight='bold' textAlign='center'>CANCEL</Text>
                </TouchableOpacity>
                :
                <TouchableOpacity style={{ flex:1, padding:10, backgroundColor:Colors.utility.success, borderBottomRightRadius:10 }} onPress={() => handleBuyNow()}>
                    <Text size={14} color={Colors.shades.white} weight='bold' textAlign='center'>BUY</Text>
                </TouchableOpacity>
                }
            </View>
        </View>
    )
}

const styles = {
    orderCard: { justifyContent:'center', borderRadius: 10, backgroundColor: Colors.shades.white, shadowColor: "rgba(0, 0, 0, 0.12)", shadowOffset: { width: 0, height: 10 }, shadowRadius: 10, shadowOpacity: 1 },
}

export default BuyNowOrderCard